import { render, staticRenderFns } from "./SetupPureNewDevice.vue?vue&type=template&id=c9c679cc"
import script from "./SetupPureNewDevice.vue?vue&type=script&lang=js"
export * from "./SetupPureNewDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports